import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  Row,
  Spinner,
  TabContent,
  TabPane
} from "reactstrap";
import classnames from "classnames";
import DataTable from "react-data-table-component";
import eye_icon from "../../assets/images/view 1.png";
import { withTranslation } from "react-i18next";
import StaticData from "../../static/data";
import {
  getStripeSubscription,
  getStripePaymentMethod,
  getStripeInvoicesList,
  calculator_id,
  SMARTAS,
  formatDate
} from "../../helpers/api_helper";
import CrossOutlined from "../../assets/images/icons/CrossOutlined";
import Calculator from "./component/Calculator";
import CalculatorModal from "../../components/Common/CalculatorModal/CalculatorModal";
import CalculatorOneShotModal from "../../components/Common/CalculatorModal/CalculatorOneShotModal";
import { useDispatch, useSelector } from "react-redux";

const billsList = [
  { $id: "1", date: "2021 21,Oct.", type: "AnnualPro", download_link: "#" },
  {
    $id: "2",
    date: "Aug. 21, 2021",
    type: "Pro Portfolio",
    download_link: "#"
  },
  {
    $id: "3",
    date: "July. 21, 2021",
    type: "Sponsored Post",
    download_link: "#"
  },
  {
    $id: "4",
    date: "Jun. 21, 2021",
    type: "Sponsored Post",
    download_link: "#"
  },
  { $id: "5", date: "May. 21, 2021", type: "AnnualPro", download_link: "#" }
];
const Facturation = (props) => {
  const [listPlans, setListPlans] = useState();
  const [listFeatures, setListFeatures] = useState();
  const [listFeatureTitle, setListFeatureTitle] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [activeSubscriptionPlan, setActiveSubscriptionPlan] =
    useState(undefined);
  const [primaryPaymentSource, setPrimaryPaymentSource] = useState(null);
  const [invoiceList, setInvoiceList] = useState();
  const [loadingStripeInfos, setLoadingStripeInfos] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  const cardRef = useRef();

  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  let navigate = useNavigate();

  const options = {
    classes: {
      focus: "focus",
      invalid: "invalid",
      empty: "empty",
      complete: "complete"
    },
    style: {
      base: {
        color: "#333",
        fontWeight: "500",
        fontFamily: "Roboto, Segoe UI, Helvetica Neue, sans-serif",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        ":focus": {
          color: "#424770"
        },
        "::placeholder": {
          color: "transparent"
        },
        ":focus::placeholder": {
          color: "#7b808c"
        },
        ":-webkit-autofill": {
          webkitTextColor: "#333"
        }
      },
      invalid: {
        color: "#e41029",
        ":focus": {
          color: "#e44d5f"
        },
        "::placeholder": {
          color: "#FFCCA5"
        }
      }
    },
    locale: "en",
    placeholder: {
      number: "4111 1111 1111 1111",
      expiry: "MM / YY",
      cvv: "CVV"
    },
    fonts: ["https://fonts.googleapis.com/css?family=Roboto:300,500,600"]
  };

  const handleChange = useCallback((event) => {
    const { value } = event.target;
    setFirstName(value);
  }, []);

  const svgs = {
    check_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
      >
        <path
          d="M20.9949 2.0168C20.8615 2.5003 20.5279 2.84638 20.1842 3.18738C16.4077 6.92815 12.6313 10.674 8.86001 14.4199C8.44439 14.8321 7.96721 15.051 7.37201 14.9899C6.96153 14.9492 6.61775 14.7609 6.33041 14.4759C4.39089 12.5571 2.45136 10.6435 0.52723 8.71456C-0.334782 7.84934 -0.103886 6.5159 0.958235 5.99677C1.62014 5.67105 2.36927 5.81355 2.94394 6.38357C4.16512 7.59487 5.38631 8.80617 6.60749 10.0175C6.88456 10.2923 7.16164 10.562 7.43358 10.8369C7.53107 10.9387 7.60291 10.9387 7.7004 10.8369C7.9826 10.5468 8.2802 10.2618 8.56754 9.97166C11.7077 6.85689 14.853 3.73704 17.9932 0.622277C18.4088 0.210029 18.8758 -0.0444449 19.4863 0.00644996C20.1483 0.0624343 20.7383 0.520488 20.9333 1.15158C20.9538 1.20757 20.9795 1.26355 21 1.31954C20.9949 1.55365 20.9949 1.78268 20.9949 2.0168Z"
          fill="white"
        />
      </svg>
    ),
    option_available: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M14.2432 0.101562C17.5983 0.101562 19.845 2.45707 19.845 5.96064V14.0476C19.845 17.5402 17.5983 19.8958 14.2432 19.8958H5.66243C2.30732 19.8958 0.0507812 17.5402 0.0507812 14.0476V5.96064C0.0507812 2.45707 2.30732 0.101562 5.66243 0.101562H14.2432ZM14.0849 7.02953C13.7484 6.69303 13.1941 6.69303 12.8576 7.02953L8.77012 11.117L7.03813 9.38504C6.70163 9.04854 6.14739 9.04854 5.81089 9.38504C5.47439 9.72154 5.47439 10.2659 5.81089 10.6123L8.1664 12.9579C8.33465 13.1261 8.55239 13.2053 8.77012 13.2053C8.99776 13.2053 9.21549 13.1261 9.38374 12.9579L14.0849 8.25677C14.4214 7.92027 14.4214 7.37593 14.0849 7.02953Z"
          fill="#329993"
        />
      </svg>
    ),
    option_unavailable: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M14.2432 0.402344C17.5983 0.402344 19.845 2.75785 19.845 6.26142V14.3483C19.845 17.841 17.5983 20.1965 14.2432 20.1965H5.66243C2.30732 20.1965 0.0507812 17.841 0.0507812 14.3483V6.26142C0.0507812 2.75785 2.30732 0.402344 5.66243 0.402344H14.2432Z"
          fill="#A7AABA"
        />
      </svg>
    ),
    bin_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="21"
        viewBox="0 0 19 21"
        fill="none"
      >
        <path
          d="M17.3009 7.1875L16.563 18.1413C16.5186 18.808 16.2228 19.433 15.7354 19.8902C15.248 20.3473 14.6054 20.6025 13.9371 20.6042H5.06297C4.39475 20.6025 3.75207 20.3473 3.26469 19.8902C2.77731 19.433 2.48155 18.808 2.43714 18.1413L1.69922 7.1875H17.3009ZM12.4824 4.3125H6.51772C6.25203 4.31239 5.99017 4.2492 5.75368 4.12812C5.51719 4.00704 5.31283 3.83154 5.15741 3.61605C5.002 3.40057 4.89997 3.15126 4.85972 2.88864C4.81948 2.62602 4.84217 2.3576 4.92593 2.10546L5.24697 1.14617C5.35763 0.812294 5.57075 0.521813 5.85601 0.316039C6.14127 0.110265 6.48415 -0.000323782 6.83589 9.24437e-07H12.1623C12.5144 -0.00036899 12.8577 0.110286 13.1433 0.316229C13.4289 0.522173 13.6423 0.812921 13.7531 1.14713L14.0723 2.1045C14.1564 2.35662 14.1794 2.62513 14.1394 2.88789C14.0994 3.15065 13.9975 3.40013 13.8421 3.61578C13.6868 3.83143 13.4824 4.00706 13.2458 4.12819C13.0092 4.24933 12.7472 4.3125 12.4814 4.3125H12.4824ZM6.83684 1.4375C6.78663 1.43718 6.7376 1.45277 6.6968 1.48204C6.656 1.51131 6.62551 1.55275 6.60972 1.60042L6.28964 2.55971C6.27759 2.59586 6.27435 2.63436 6.28017 2.67202C6.28599 2.70968 6.30071 2.74541 6.3231 2.77623C6.3455 2.80706 6.37493 2.83211 6.40894 2.84928C6.44295 2.86646 6.48057 2.87528 6.51868 2.875H12.4833C12.5215 2.87518 12.5591 2.86624 12.5931 2.84895C12.6271 2.83165 12.6565 2.8065 12.6788 2.77556C12.7011 2.74463 12.7157 2.70882 12.7214 2.67111C12.727 2.6334 12.7236 2.59488 12.7114 2.55875L12.3923 1.60138C12.3764 1.55353 12.3457 1.51194 12.3048 1.48251C12.2638 1.45309 12.2146 1.43734 12.1642 1.4375H6.83684Z"
          fill="#F7F8FB"
        />
        <path
          d="M7.58203 14.8538C7.39141 14.8538 7.20859 14.7781 7.0738 14.6433C6.93901 14.5085 6.86328 14.3257 6.86328 14.1351V10.3018C6.86328 10.1111 6.93901 9.92832 7.0738 9.79353C7.20859 9.65873 7.39141 9.58301 7.58203 9.58301C7.77266 9.58301 7.95547 9.65873 8.09026 9.79353C8.22506 9.92832 8.30078 10.1111 8.30078 10.3018V14.1351C8.30078 14.3257 8.22506 14.5085 8.09026 14.6433C7.95547 14.7781 7.77266 14.8538 7.58203 14.8538ZM11.4154 14.8538C11.2247 14.8538 11.0419 14.7781 10.9071 14.6433C10.7723 14.5085 10.6966 14.3257 10.6966 14.1351V10.3018C10.6966 10.1111 10.7723 9.92832 10.9071 9.79353C11.0419 9.65873 11.2247 9.58301 11.4154 9.58301C11.606 9.58301 11.7888 9.65873 11.9236 9.79353C12.0584 9.92832 12.1341 10.1111 12.1341 10.3018V14.1351C12.1341 14.3257 12.0584 14.5085 11.9236 14.6433C11.7888 14.7781 11.606 14.8538 11.4154 14.8538Z"
          fill="#F10944"
        />
        <path
          d="M17.1667 2.875H1.83333C1.38854 2.875 0.961971 3.05169 0.647456 3.36621C0.332942 3.68072 0.15625 4.10729 0.15625 4.55208C0.15625 4.99687 0.332942 5.42345 0.647456 5.73796C0.961971 6.05247 1.38854 6.22917 1.83333 6.22917H17.1667C17.6115 6.22917 18.038 6.05247 18.3525 5.73796C18.6671 5.42345 18.8438 4.99687 18.8438 4.55208C18.8438 4.10729 18.6671 3.68072 18.3525 3.36621C18.038 3.05169 17.6115 2.875 17.1667 2.875Z"
          fill="#F7F8FB"
        />
      </svg>
    ),
    credit_card_vector: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="302"
        height="202"
        viewBox="0 0 302 202"
        fill="none"
      >
        <path
          d="M149.288 164.455C149.288 205.611 115.925 238.974 74.7692 238.974C33.6134 238.974 0.25 205.611 0.25 164.455C0.25 142.756 9.52425 123.224 24.3251 109.605C37.5968 97.393 55.3122 89.936 74.7692 89.936C115.925 89.936 149.288 123.299 149.288 164.455Z"
          fill="white"
          style={{ fillOpacity: "0.12" }}
        />
        <path
          d="M149.288 164.455C149.288 205.611 115.925 238.974 74.7692 238.974H289.837C248.681 238.974 215.318 205.611 215.318 164.455C215.318 159.198 215.862 154.068 216.897 149.119C213.388 149.626 209.799 149.888 206.15 149.888C169.979 149.888 139.827 124.118 133.054 89.936H84.4442H74.7692C115.925 89.936 149.288 123.299 149.288 164.455Z"
          fill="white"
          style={{ fillOpacity: "0.12" }}
        />
        <path
          d="M133.054 89.936C132.12 85.2249 131.63 80.354 131.63 75.3688C131.63 68.8214 132.475 62.4713 134.061 56.4214C127.833 67.5929 109.192 89.936 84.4442 89.936H133.054Z"
          fill="white"
          style={{ fillOpacity: "0.12" }}
        />
        <path
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fillOpacity: "0.12"
          }}
          d="M289.837 238.974C330.993 238.974 364.356 205.611 364.356 164.455C364.356 123.299 330.993 89.936 289.837 89.936C286.187 89.936 282.598 90.1984 279.089 90.7054C272.737 121.067 247.906 144.639 216.897 149.119C215.862 154.068 215.318 159.198 215.318 164.455C215.318 205.611 248.681 238.974 289.837 238.974Z"
          fill="white"
        />
        <path
          d="M279.089 90.7054C272.737 121.067 247.906 144.639 216.897 149.119C223.249 118.757 248.081 95.1847 279.089 90.7054Z"
          fill="white"
          style={{ fillOpacity: "0.12" }}
        />
        <path
          d="M280.669 75.3688C280.669 34.213 247.305 0.849609 206.15 0.849609C171.541 0.849609 142.443 24.442 134.061 56.4214C132.475 62.4713 131.63 68.8214 131.63 75.3688C131.63 80.354 132.12 85.2249 133.054 89.936C139.827 124.118 169.979 149.888 206.15 149.888C209.799 149.888 213.388 149.626 216.897 149.119C223.249 118.757 248.081 95.1847 279.089 90.7054C280.124 85.7559 280.669 80.6259 280.669 75.3688Z"
          fill="white"
          style={{ fillOpacity: "0.12" }}
        />
      </svg>
    ),
    visa: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ float: "inline-end" }}
        width="72"
        height="26"
        viewBox="0 0 78 26"
        fill="none"
      >
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M34.2458 24.7842H28L31.9066 1.25977H38.152L34.2458 24.7842Z"
          fill="currentColor"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M56.888 1.83551C55.656 1.35953 53.7021 0.833984 51.286 0.833984C45.1181 0.833984 40.7747 4.03715 40.7481 8.61672C40.6968 11.9955 43.8578 13.8722 46.222 14.9988C48.6384 16.15 49.4598 16.9014 49.4598 17.9275C49.4352 19.5035 47.5072 20.2299 45.709 20.2299C43.2154 20.2299 41.8793 19.8554 39.8488 18.9786L39.0264 18.6027L38.1523 23.8835C39.6172 24.5334 42.3161 25.1102 45.1181 25.1355C51.6716 25.1355 55.9382 21.9819 55.9887 17.1016C56.0136 14.4237 54.3445 12.3717 50.746 10.6949C48.5615 9.61858 47.2237 8.89279 47.2237 7.79148C47.2493 6.79028 48.3552 5.7648 50.8212 5.7648C52.8516 5.71457 54.3435 6.18989 55.4737 6.66554L56.0386 6.91535L56.888 1.83551Z"
          fill="currentColor"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M68.0691 1.25977H72.9002L77.939 24.7839H72.156C72.156 24.7839 71.5901 22.081 71.4108 21.2551H63.3917C63.1598 21.8804 62.0809 24.7839 62.0809 24.7839H55.5273L64.8047 3.2116C65.4474 1.68486 66.5793 1.25977 68.0691 1.25977ZM67.6848 9.8684C67.6848 9.8684 65.7056 15.0989 65.1912 16.4504H70.3827C70.1258 15.2742 68.9431 9.64322 68.9431 9.64322L68.5066 7.61621C68.3228 8.13817 68.057 8.85578 67.8777 9.33981C67.7561 9.66792 67.6744 9.88869 67.6848 9.8684Z"
          fill="currentColor"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M22.7836 1.25977L16.6669 17.3012L15.9985 14.0478C14.8676 10.2938 11.3211 6.21519 7.36328 4.18719L12.9659 24.7593H19.5707L29.388 1.25977H22.7836V1.25977Z"
          fill="currentColor"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M10.9876 1.25977H0.938742L0.835938 1.73508C8.67467 3.68725 13.8661 8.39288 15.999 14.0488L13.8145 3.23721C13.4549 1.73475 12.3497 1.30933 10.9876 1.25977Z"
          fill="currentColor"
        />
      </svg>
    ),
    plus_credit_card_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M15.6579 7.15789H9.8421V1.34211C9.8421 0.986157 9.7007 0.644787 9.44901 0.393093C9.19732 0.1414 8.85595 0 8.5 0C8.14405 0 7.80268 0.1414 7.55099 0.393093C7.2993 0.644787 7.15789 0.986157 7.15789 1.34211V7.15789H1.34211C0.986157 7.15789 0.644787 7.2993 0.393093 7.55099C0.1414 7.80268 0 8.14405 0 8.5C0 8.85595 0.1414 9.19732 0.393093 9.44901C0.644787 9.7007 0.986157 9.8421 1.34211 9.8421H7.15789V15.6579C7.15789 16.0138 7.2993 16.3552 7.55099 16.6069C7.80268 16.8586 8.14405 17 8.5 17C8.85595 17 9.19732 16.8586 9.44901 16.6069C9.7007 16.3552 9.8421 16.0138 9.8421 15.6579V9.8421H15.6579C16.0138 9.8421 16.3552 9.7007 16.6069 9.44901C16.8586 9.19732 17 8.85595 17 8.5C17 8.14405 16.8586 7.80268 16.6069 7.55099C16.3552 7.2993 16.0138 7.15789 15.6579 7.15789Z"
          fill="black"
        />
      </svg>
    ),
    check_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="14"
        viewBox="0 0 20 14"
        fill="none"
      >
        <path
          d="M19.9951 1.88234C19.8681 2.33361 19.5504 2.65662 19.223 2.97489C15.6264 6.46627 12.0298 9.96241 8.4381 13.4585C8.04228 13.8433 7.58782 14.0476 7.02096 13.9906C6.63003 13.9526 6.30262 13.7768 6.02897 13.5108C4.1818 11.72 2.33463 9.93391 0.502123 8.13359C-0.31884 7.32605 -0.098939 6.08151 0.912605 5.59699C1.54299 5.29298 2.25644 5.42598 2.80375 5.958C3.96678 7.08855 5.12982 8.21909 6.29285 9.34963C6.55673 9.60614 6.82061 9.8579 7.0796 10.1144C7.17245 10.2094 7.24086 10.2094 7.33371 10.1144C7.60248 9.84365 7.88591 9.57764 8.15956 9.30688C11.1502 6.39977 14.1458 3.48791 17.1364 0.580792C17.5322 0.196027 17.9769 -0.0414819 18.5584 0.00601996C19.1888 0.058272 19.7508 0.485789 19.9365 1.07481C19.956 1.12706 19.9805 1.17932 20 1.23157C19.9951 1.45008 19.9951 1.66383 19.9951 1.88234Z"
          fill="white"
        />
      </svg>
    ),
    master_card_logo: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="43"
        viewBox="0 0 56 43"
        fill="none"
      >
        <g style={{ clipPath: "url(#clip0_1148_3050)" }}>
          <path
            d="M10.1517 42.9056V40.0519C10.1517 38.9603 9.47912 38.2454 8.32459 38.2454C7.74733 38.2454 7.11963 38.4338 6.68808 39.0545C6.35182 38.5336 5.86983 38.2454 5.14685 38.2454C4.66487 38.2454 4.18288 38.3895 3.80178 38.9104V38.3396H2.79297V42.9056H3.80178V40.3844C3.80178 39.5753 4.23332 39.193 4.90586 39.193C5.5784 39.193 5.91467 39.6197 5.91467 40.3844V42.9056H6.92347V40.3844C6.92347 39.5753 7.40546 39.193 8.02756 39.193C8.70009 39.193 9.03636 39.6197 9.03636 40.3844V42.9056H10.1517ZM25.1156 38.3396H23.4791V36.9599H22.4703V38.3396H21.5568V39.2429H22.4703V41.3375C22.4703 42.3847 22.9019 42.9998 24.0564 42.9998C24.4879 42.9998 24.9699 42.8558 25.3062 42.6674L25.0147 41.8085C24.7233 41.9969 24.387 42.0467 24.1461 42.0467C23.6641 42.0467 23.4735 41.7586 23.4735 41.2876V39.2429H25.11V38.3396H25.1156ZM33.6793 38.2399C33.102 38.2399 32.7153 38.528 32.4743 38.9049V38.3341H31.4655V42.9001H32.4743V40.329C32.4743 39.5698 32.8106 39.1376 33.4383 39.1376C33.6288 39.1376 33.8698 39.1875 34.066 39.2318L34.3574 38.2787C34.1557 38.2399 33.8698 38.2399 33.6793 38.2399ZM20.7385 38.7165C20.2565 38.384 19.584 38.2399 18.861 38.2399C17.7065 38.2399 16.9387 38.8107 16.9387 39.7139C16.9387 40.473 17.5159 40.9052 18.5248 41.0438L19.0067 41.0936C19.5336 41.1878 19.825 41.3319 19.825 41.5702C19.825 41.9027 19.4383 42.1409 18.7657 42.1409C18.0932 42.1409 17.5608 41.9027 17.2245 41.6644L16.7425 42.4235C17.2694 42.8059 17.9923 42.9943 18.7153 42.9943C20.0604 42.9943 20.8338 42.3737 20.8338 41.5203C20.8338 40.7113 20.2061 40.2846 19.2477 40.1406L18.7657 40.0907C18.3342 40.0408 17.9979 39.9466 17.9979 39.664C17.9979 39.3315 18.3342 39.1431 18.8666 39.1431C19.4439 39.1431 20.0212 39.3814 20.3126 39.5255L20.7385 38.7165ZM47.5784 38.2399C47.0011 38.2399 46.6144 38.528 46.3734 38.9049V38.3341H45.3646V42.9001H46.3734V40.329C46.3734 39.5698 46.7097 39.1376 47.3374 39.1376C47.528 39.1376 47.7689 39.1875 47.9651 39.2318L48.2565 38.2898C48.0604 38.2399 47.7746 38.2399 47.5784 38.2399ZM34.6881 40.6226C34.6881 42.0024 35.6521 42.9998 37.1428 42.9998C37.8154 42.9998 38.2974 42.8558 38.7794 42.479L38.2974 41.6699C37.9107 41.9581 37.5296 42.0966 37.0924 42.0966C36.2742 42.0966 35.6969 41.5259 35.6969 40.6226C35.6969 39.7637 36.2742 39.193 37.0924 39.1487C37.524 39.1487 37.9107 39.2927 38.2974 39.5753L38.7794 38.7663C38.2974 38.384 37.8154 38.2454 37.1428 38.2454C35.6521 38.2399 34.6881 39.2429 34.6881 40.6226ZM44.0196 40.6226V38.3396H43.0107V38.9104C42.6745 38.4837 42.1925 38.2454 41.5648 38.2454C40.2645 38.2454 39.2557 39.2429 39.2557 40.6226C39.2557 42.0024 40.2645 42.9998 41.5648 42.9998C42.2373 42.9998 42.7193 42.7616 43.0107 42.3349V42.9056H44.0196V40.6226ZM40.315 40.6226C40.315 39.8136 40.8418 39.1487 41.7105 39.1487C42.5288 39.1487 43.106 39.7693 43.106 40.6226C43.106 41.4317 42.5288 42.0966 41.7105 42.0966C40.8474 42.0467 40.315 41.4261 40.315 40.6226ZM28.2429 38.2399C26.8979 38.2399 25.9339 39.193 25.9339 40.6171C25.9339 42.0467 26.8979 42.9943 28.2934 42.9943C28.9659 42.9943 29.6384 42.8059 30.1709 42.3737L29.6889 41.6588C29.3022 41.947 28.8202 42.1354 28.3438 42.1354C27.7161 42.1354 27.094 41.8473 26.9483 41.0438H30.3614C30.3614 40.8997 30.3614 40.8055 30.3614 40.6614C30.4063 39.193 29.5376 38.2399 28.2429 38.2399ZM28.2429 39.0988C28.8706 39.0988 29.3022 39.4811 29.3975 40.1904H26.9931C27.0884 39.5753 27.52 39.0988 28.2429 39.0988ZM53.3062 40.6226V36.5332H52.2974V38.9104C51.9611 38.4837 51.4791 38.2454 50.8514 38.2454C49.5512 38.2454 48.5424 39.2429 48.5424 40.6226C48.5424 42.0024 49.5512 42.9998 50.8514 42.9998C51.524 42.9998 52.0059 42.7616 52.2974 42.3349V42.9056H53.3062V40.6226ZM49.6016 40.6226C49.6016 39.8136 50.1284 39.1487 50.9971 39.1487C51.8154 39.1487 52.3926 39.7693 52.3926 40.6226C52.3926 41.4317 51.8154 42.0966 50.9971 42.0966C50.1284 42.0467 49.6016 41.4261 49.6016 40.6226ZM15.829 40.6226V38.3396H14.8202V38.9104C14.4839 38.4837 14.0019 38.2454 13.3742 38.2454C12.074 38.2454 11.0652 39.2429 11.0652 40.6226C11.0652 42.0024 12.074 42.9998 13.3742 42.9998C14.0468 42.9998 14.5288 42.7616 14.8202 42.3349V42.9056H15.829V40.6226ZM12.0796 40.6226C12.0796 39.8136 12.6064 39.1487 13.4751 39.1487C14.2934 39.1487 14.8706 39.7693 14.8706 40.6226C14.8706 41.4317 14.2934 42.0966 13.4751 42.0966C12.6064 42.0467 12.0796 41.4261 12.0796 40.6226Z"
            fill="black"
          />
          <path
            d="M35.553 3.66309H20.3984V30.5824H35.553V3.66309Z"
            fill="#FF5A00"
          />
          <path
            d="M21.4091 17.1224C21.4091 11.6532 24.0096 6.7991 28 3.66276C25.0633 1.37977 21.3587 0 17.3179 0C7.7454 0 0 7.65799 0 17.1224C0 26.5869 7.7454 34.2448 17.3179 34.2448C21.3587 34.2448 25.0633 32.8651 28 30.5821C24.004 27.4901 21.4091 22.5916 21.4091 17.1224Z"
            fill="#EB001B"
          />
          <path
            d="M56 17.1224C56 26.5869 48.2546 34.2448 38.6821 34.2448C34.6413 34.2448 30.9367 32.8651 28 30.5821C32.0408 27.4402 34.5909 22.5916 34.5909 17.1224C34.5909 11.6532 31.9904 6.7991 28 3.66276C30.9311 1.37977 34.6357 0 38.6765 0C48.2546 0 56 7.70786 56 17.1224Z"
            fill="#F79E1B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1148_3050">
            <rect width="56" height="43" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    visa_logo_color: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="109"
        height="35"
        viewBox="0 0 109 35"
        fill="none"
      >
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M47.0539 33.7306H38.2578L43.7595 0.600586H52.5551L47.0539 33.7306Z"
          fill="#0057A0"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M78.9365 1.41047C77.2016 0.740136 74.4498 0 71.0472 0C62.3608 0 56.2439 4.51108 56.2064 10.9606C56.1342 15.719 60.5859 18.3619 63.9154 19.9485C67.3185 21.5698 68.4753 22.628 68.4753 24.0732C68.4406 26.2926 65.7254 27.3157 63.1929 27.3157C59.6811 27.3157 57.7995 26.7882 54.9399 25.5534L53.7817 25.0241L52.5508 32.461C54.6138 33.3764 58.4147 34.1887 62.3608 34.2243C71.5902 34.2243 77.5989 29.783 77.6701 22.91C77.7052 19.1386 75.3545 16.2488 70.2867 13.8874C67.2102 12.3715 65.3262 11.3494 65.3262 9.79837C65.3622 8.38836 66.9197 6.94416 70.3925 6.94416C73.2521 6.87343 75.3531 7.54283 76.9447 8.2127L77.7403 8.5645L78.9365 1.41047Z"
          fill="#0057A0"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M94.6863 0.600586H101.49L108.586 33.7301H100.442C100.442 33.7301 99.6449 29.9236 99.3924 28.7604H88.099C87.7724 29.6411 86.2529 33.7301 86.2529 33.7301H77.0234L90.0889 3.34939C90.9941 1.19925 92.5881 0.600586 94.6863 0.600586ZM94.1485 12.7243C94.1485 12.7243 91.3611 20.0905 90.6367 21.9938H97.9479C97.5862 20.3374 95.9205 12.4072 95.9205 12.4072L95.3058 9.55249C95.0469 10.2876 94.6726 11.2982 94.4201 11.9799C94.2489 12.442 94.1337 12.7529 94.1485 12.7243Z"
          fill="#0057A0"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M30.9081 0.600586L22.2939 23.1921L21.3525 18.6102C19.7599 13.3234 14.7652 7.57941 9.19141 4.72333L17.0817 33.6954H26.3833L40.2092 0.600586H30.9081V0.600586Z"
          fill="#0057A0"
        />
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M14.2968 0.600586H0.144781L0 1.26999C11.0394 4.01926 18.3506 10.6463 21.3545 18.6117L18.278 3.38546C17.7715 1.26952 16.215 0.670384 14.2968 0.600586Z"
          fill="#FAA61A"
        />
      </svg>
    ),
    amex_logo: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
      >
        <path
          d="M0.28125 0H41.0005V21.2367V24.2792V26.9871V39.3396H0.28125V19.3199V17.9354V16.5817V0Z"
          fill="#016FD0"
        />
        <path
          d="M8.74219 27.3999V21.2266H15.2786L15.9799 22.1408L16.7043 21.2266H40.705V27.3999C40.705 27.3999 39.8093 27.3937 39.0917 27.3999H25.9545L25.1638 26.4267V27.3999H22.5728V25.7387C22.5728 25.7387 22.2189 25.9706 21.4537 25.9706H20.5718V27.3999H16.6489L15.9486 26.4661L15.2376 27.3999H8.74219Z"
          fill="white"
        />
        <path
          d="M0.515625 18.4079L2.58088 13.1367H5.12998L5.96648 15.0616V13.1367H9.13524L9.63321 14.528L10.116 13.1367H24.3404V13.8362C24.3404 13.8362 25.0882 13.1367 26.3171 13.1367L30.9324 13.1528L31.7545 15.0526V13.1367H34.4063L35.1361 14.228V13.1367H37.8122V19.31H35.1361L34.4367 18.2152V19.31H30.5406L30.1488 18.3369H29.1014L28.716 19.31H26.0738C25.0164 19.31 24.3404 18.6249 24.3404 18.6249V19.31H20.3567L19.566 18.3369V19.31H4.75234L4.36081 18.3369H3.31676L2.92799 19.31H0.515625V18.4079Z"
          fill="white"
        />
        <path
          d="M3.10917 13.8984L1.12109 18.5208H2.41543L2.78226 17.5952H4.91479L5.27971 18.5208H6.60256L4.61638 13.8984H3.10917ZM3.84472 14.9742L4.49474 16.5917H3.1928L3.84472 14.9742Z"
          fill="#016FD0"
        />
        <path
          d="M6.73438 18.5208V13.8984L8.57371 13.9053L9.64352 16.8855L10.6877 13.8984H12.5123V18.5208H11.3567V15.1149L10.1318 18.5208H9.11834L7.88997 15.1149V18.5208H6.73438Z"
          fill="#016FD0"
        />
        <path
          d="M13.3047 18.5208V13.8984H17.0756V14.9324H14.4724V15.7231H17.0148V16.6962H14.4724V17.5173H17.0756V18.5208H13.3047Z"
          fill="#016FD0"
        />
        <path
          d="M17.7422 13.8984V18.5208H18.8978V16.8787H19.3843L20.7699 18.5208H22.1821L20.6616 16.8178C21.2856 16.7652 21.9293 16.2296 21.9293 15.3981C21.9293 14.4253 21.1658 13.8984 20.3138 13.8984H17.7422ZM18.8978 14.9324H20.2187C20.5356 14.9324 20.7661 15.1803 20.7661 15.419C20.7661 15.726 20.4675 15.9055 20.2358 15.9055H18.8978V14.9324Z"
          fill="#016FD0"
        />
        <path
          d="M23.5784 18.5208H22.3984V13.8984H23.5784V18.5208Z"
          fill="#016FD0"
        />
        <path
          d="M26.3797 18.5208H26.125C24.8927 18.5208 24.1445 17.55 24.1445 16.2286C24.1445 14.8747 24.8843 13.8984 26.4405 13.8984H27.7178V14.9932H26.3938C25.7621 14.9932 25.3153 15.4862 25.3153 16.24C25.3153 17.1352 25.8262 17.5112 26.5622 17.5112H26.8663L26.3797 18.5208Z"
          fill="#016FD0"
        />
        <path
          d="M28.8943 13.8984L26.9062 18.5208H28.2006L28.5674 17.5952H30.6999L31.0649 18.5208H32.3877L30.4015 13.8984H28.8943ZM29.6299 14.9742L30.2799 16.5917H28.978L29.6299 14.9742Z"
          fill="#016FD0"
        />
        <path
          d="M32.5234 18.5208V13.8984H33.9926L35.8686 16.8026V13.8984H37.0242V18.5208H35.6025L33.679 15.5406V18.5208H32.5234Z"
          fill="#016FD0"
        />
        <path
          d="M9.53125 26.6087V21.9863H13.3021V23.0203H10.699V23.811H13.2413V24.7841H10.699V25.6052H13.3021V26.6087H9.53125Z"
          fill="#016FD0"
        />
        <path
          d="M28.0117 26.6087V21.9863H31.7826V23.0203H29.1795V23.811H31.7096V24.7841H29.1795V25.6052H31.7826V26.6087H28.0117Z"
          fill="#016FD0"
        />
        <path
          d="M13.45 26.6087L15.286 24.326L13.4062 21.9863H14.8621L15.9816 23.4327L17.1049 21.9863H18.5038L16.6488 24.2975L18.4882 26.6087H17.0325L15.9455 25.1851L14.885 26.6087H13.45Z"
          fill="#016FD0"
        />
        <path
          d="M18.625 21.9883V26.6107H19.811V25.151H21.0274C22.0567 25.151 22.8368 24.6049 22.8368 23.543C22.8368 22.6633 22.225 21.9883 21.1776 21.9883H18.625ZM19.811 23.0336H21.092C21.4246 23.0336 21.6622 23.2374 21.6622 23.5658C21.6622 23.8743 21.4258 24.098 21.0882 24.098H19.811V23.0336Z"
          fill="#016FD0"
        />
        <path
          d="M23.3398 21.9863V26.6087H24.4954V24.9665H24.982L26.3676 26.6087H27.7798L26.2592 24.9057C26.8833 24.8531 27.527 24.3175 27.527 23.4859C27.527 22.5132 26.7635 21.9863 25.9114 21.9863H23.3398ZM24.4954 23.0203H25.8164C26.1333 23.0203 26.3638 23.2682 26.3638 23.5068C26.3638 23.8139 26.0651 23.9934 25.8335 23.9934H24.4954V23.0203Z"
          fill="#016FD0"
        />
        <path
          d="M32.3186 26.6087V25.6052H34.6313C34.9735 25.6052 35.1217 25.4202 35.1217 25.2174C35.1217 25.0231 34.974 24.8267 34.6313 24.8267H33.5862C32.6778 24.8267 32.1719 24.2732 32.1719 23.4422C32.1719 22.7011 32.6352 21.9863 33.9851 21.9863H36.2355L35.7489 23.0264H33.8026C33.4306 23.0264 33.3161 23.2216 33.3161 23.408C33.3161 23.5996 33.4576 23.811 33.7418 23.811H34.8366C35.8493 23.811 36.2887 24.3854 36.2887 25.1376C36.2887 25.9463 35.799 26.6087 34.7815 26.6087H32.3186Z"
          fill="#016FD0"
        />
        <path
          d="M36.5569 26.6087V25.6052H38.8696C39.2118 25.6052 39.36 25.4202 39.36 25.2174C39.36 25.0231 39.2123 24.8267 38.8696 24.8267H37.8245C36.9161 24.8267 36.4102 24.2732 36.4102 23.4422C36.4102 22.7011 36.8735 21.9863 38.2234 21.9863H40.4737L39.9872 23.0264H38.0409C37.6689 23.0264 37.5543 23.2216 37.5543 23.408C37.5543 23.5996 37.6959 23.811 37.9801 23.811H39.0749C40.0875 23.811 40.527 24.3854 40.527 25.1376C40.527 25.9463 40.0373 26.6087 39.0197 26.6087H36.5569Z"
          fill="#016FD0"
        />
      </svg>
    ),
    mastercard: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="46"
        height="29"
        viewBox="0 0 46 29"
        fill="none"
      >
        <path
          d="M29.2062 3.00781H16.7578V25.1201H29.2062V3.00781Z"
          fill="#FF5A00"
        />
        <path
          d="M17.5861 14.0648C17.5861 9.57229 19.7222 5.58497 23 3.00869C20.5877 1.13338 17.5446 0 14.2254 0C6.36229 0 0 6.29049 0 14.0648C0 21.8392 6.36229 28.1297 14.2254 28.1297C17.5446 28.1297 20.5877 26.9963 23 25.121C19.7176 22.5811 17.5861 18.5574 17.5861 14.0648Z"
          fill="#EB001B"
        />
        <path
          d="M46 14.0648C46 21.8392 39.6377 28.1297 31.7746 28.1297C28.4554 28.1297 25.4123 26.9963 23 25.121C26.3193 22.5402 28.4139 18.5574 28.4139 14.0648C28.4139 9.57229 26.2778 5.58497 23 3.00869C25.4077 1.13338 28.4508 0 31.77 0C39.6377 0 46 6.33146 46 14.0648Z"
          fill="#F79E1B"
        />
      </svg>
    ),
    pdf_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="27"
        viewBox="0 0 21 27"
        fill="none"
      >
        <g style={{ clipPath: "url(#clip0_1148_3293)" }}>
          <path
            d="M0.000272416 13.5013C0.000272416 9.98307 0.000272416 6.46403 0.000272416 2.94584C0.00190691 1.16909 1.12889 0.0075642 2.85982 0.00588327C6.14843 0.00336187 9.43703 0.0075642 12.7256 0C13.0035 0 13.2029 0.0874086 13.3974 0.289121C15.8402 2.8122 18.2886 5.3294 20.7412 7.84156C20.9218 8.02646 21.0003 8.21388 20.9995 8.47695C20.9929 13.6971 20.9962 18.9164 20.9937 24.1365C20.9937 25.7948 19.8553 26.9899 18.2404 26.9924C13.0828 27.0017 7.92594 27.0008 2.76829 26.9924C1.13952 26.9908 0.00272416 25.7973 0.00108966 24.1197C-0.00136208 20.5805 0.00108966 17.0405 0.00108966 13.5013H0.000272416ZM11.8912 2.94584C11.8381 2.99711 11.8536 3.0635 11.8536 3.12402C11.8528 5.12853 11.8561 7.13388 11.8487 9.1384C11.8479 9.4023 11.9615 9.44853 12.1846 9.44769C14.1133 9.44181 16.0428 9.44517 17.9724 9.44265C18.0459 9.44265 18.135 9.48215 18.1808 9.41407C16.0845 7.25827 13.9932 5.10836 11.8912 2.94668V2.94584ZM8.49311 18.9534C8.49311 19.7199 8.49802 20.4872 8.48984 21.2537C8.48739 21.4647 8.55604 21.5412 8.76607 21.5655C9.21474 21.6185 9.66341 21.6303 10.1113 21.6067C10.6743 21.5773 11.2309 21.4899 11.74 21.2193C12.5981 20.7629 12.9332 19.9913 13.0231 19.0391C13.1514 17.6826 12.4633 16.6387 11.1688 16.3404C10.3924 16.1613 9.60702 16.2185 8.82246 16.2866C8.57565 16.3076 8.48494 16.3984 8.48903 16.6539C8.50047 17.4204 8.49311 18.1869 8.49311 18.9542V18.9534ZM4.00724 18.9214C4.00724 19.5409 4.00152 20.1594 4.00887 20.778C4.0195 21.679 3.87239 21.5344 4.77218 21.5571C5.00837 21.563 5.10317 21.4857 5.09336 21.2344C5.07865 20.836 5.10072 20.4368 5.08601 20.0384C5.07538 19.7627 5.15057 19.6241 5.44641 19.6568C5.7112 19.6871 5.97517 19.6426 6.23669 19.5913C7.16018 19.4089 7.67423 18.776 7.66361 17.8339C7.6538 16.9917 7.15283 16.4463 6.2277 16.284C5.59842 16.1739 4.96914 16.2328 4.33822 16.284C4.08896 16.3042 4.00152 16.4042 4.00479 16.6547C4.01378 17.4103 4.00806 18.1659 4.00806 18.9206L4.00724 18.9214ZM13.8853 18.9021V20.7301C13.8853 21.584 13.8853 21.5756 14.723 21.5597C14.9575 21.5555 15.0205 21.463 15.0156 21.2394C15.0041 20.7562 15.0286 20.2721 15.0066 19.7905C14.9927 19.4787 15.1087 19.3837 15.3964 19.4039C15.6914 19.424 15.9889 19.4081 16.2848 19.4081C16.8871 19.4081 16.8797 19.4081 16.8658 18.7878C16.8609 18.5718 16.789 18.4869 16.5773 18.492C16.1687 18.502 15.7601 18.4852 15.3515 18.4978C15.1079 18.5054 14.9886 18.4264 15.009 18.1574C15.0254 17.949 15.0229 17.7372 15.009 17.5279C14.9935 17.2859 15.0785 17.1884 15.3229 17.196C15.7715 17.2111 16.2218 17.1892 16.6705 17.2044C16.9108 17.2119 17.0137 17.1254 16.9892 16.8783C16.981 16.7951 16.981 16.7093 16.9892 16.6261C17.0154 16.3673 16.9099 16.274 16.6558 16.2782C15.8492 16.2899 15.0417 16.2908 14.2351 16.2782C13.9728 16.274 13.8731 16.353 13.8788 16.6354C13.8943 17.3909 13.8845 18.1482 13.8837 18.9038L13.8853 18.9021Z"
            fill="#329993"
          />
          <path
            d="M9.61707 18.9417C9.61707 18.4592 9.63423 17.976 9.61053 17.4944C9.595 17.1792 9.73639 17.0985 10.0036 17.0826C11.2001 17.0136 11.9225 17.7516 11.8514 18.982C11.7852 20.1343 11.0897 20.7865 9.97339 20.7546C9.72658 20.7478 9.60072 20.673 9.61135 20.3873C9.62933 19.9057 9.61625 19.4224 9.61625 18.94L9.61707 18.9417Z"
            fill="#329993"
          />
          <path
            d="M5.09029 17.9335C5.09029 17.8814 5.07884 17.8259 5.09192 17.7772C5.15567 17.5385 4.90722 17.1662 5.34445 17.0863C5.91979 16.9813 6.38889 17.2048 6.52456 17.6217C6.67248 18.0772 6.47634 18.5168 6.04156 18.7009C5.98517 18.7244 5.92633 18.7429 5.86749 18.7588C5.22023 18.9311 5.08947 18.8294 5.08947 18.1537C5.08947 18.0806 5.08947 18.0075 5.08947 17.9335H5.09029Z"
            fill="#329993"
          />
        </g>
        <defs>
          <clipPath id="clip0_1148_3293">
            <rect width="21" height="27" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    arrow_fwrd: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
      >
        <path
          d="M11.9716 15.7637L20 8.03942L11.9716 0.315174C11.8991 0.224039 11.807 0.148879 11.7015 0.0947829C11.596 0.0406863 11.4796 0.00891594 11.3601 0.00162216C11.2407 -0.00567163 11.121 0.011682 11.0092 0.0525076C10.8974 0.0933332 10.796 0.156678 10.712 0.238253C10.628 0.319829 10.5633 0.417731 10.5222 0.525331C10.4812 0.632931 10.4647 0.747717 10.4741 0.861919C10.4834 0.97612 10.5182 1.08707 10.5763 1.18726C10.6343 1.28745 10.7141 1.37454 10.8104 1.44263L16.817 7.23981L0.835422 7.23981C0.613855 7.23981 0.401363 7.32405 0.24469 7.47401C0.0880182 7.62396 -2.69305e-07 7.82735 -2.76601e-07 8.03942C-2.83898e-07 8.25149 0.0880181 8.45487 0.24469 8.60483C0.401363 8.75479 0.613855 8.83903 0.835422 8.83903L16.817 8.83903L10.8104 14.6362C10.6542 14.7868 10.5668 14.9906 10.5676 15.2028C10.5684 15.415 10.6572 15.6182 10.8145 15.7677C10.9718 15.9172 11.1848 16.0007 11.4065 16C11.6282 15.9992 11.8405 15.9142 11.9967 15.7637L11.9716 15.7637Z"
          fill="#FF7049"
        />
      </svg>
    ),
    close_icon: (
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.37 19.6142C19.0771 19.8983 18.778 20.038 18.4725 20.0334C18.1504 20.0115 17.8473 19.8542 17.5632 19.5613L12.9511 14.8068L8.27403 19.3437C7.98118 19.6278 7.68204 19.7675 7.3766 19.7629C7.07117 19.7582 6.78476 19.6181 6.5174 19.3425C6.25003 19.0668 6.11866 18.7763 6.12331 18.4709C6.12795 18.1654 6.2767 17.8707 6.56955 17.5866L11.2466 13.0497L6.78484 8.45016C6.48405 8.14008 6.33598 7.83232 6.34062 7.52688C6.34527 7.22145 6.50263 6.91834 6.81271 6.61755C7.10556 6.33347 7.39609 6.2021 7.6843 6.22346C7.98973 6.2281 8.29284 6.38546 8.59364 6.69554L13.0554 11.295L17.7324 6.75812C18.0252 6.47404 18.3244 6.33432 18.6298 6.33896C18.9353 6.34361 19.2217 6.48374 19.489 6.75937C19.7564 7.03499 19.8878 7.32552 19.8831 7.63096C19.8785 7.93639 19.7297 8.23115 19.4369 8.51523L14.7598 13.0522L19.372 17.8067C19.6561 18.0996 19.8041 18.4073 19.8162 18.73C19.8288 19.0187 19.68 19.3135 19.37 19.6142Z"
          fill="currentColor"
        />
      </svg>
    )
  };

  //
  const [selectedInvoice, setSelectedInvoice] = useState(undefined);

  const toggleVerticalIcon = (tab) => {
    if (verticalActiveTabWithIcon !== tab) {
      setverticalActiveTabWithIcon(tab);
    }
  };

  const [verticalActiveTabWithIcon, setverticalActiveTabWithIcon] =
    useState("1");

  const [isMoreClicked, setIsMoreClicked] = useState(null);
  const columns = [
    {
      minWidth: "4%",
      width: "50px",
      selector: () => (
        <input
          className="form-check-input form-check-input_invoice-table fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      )
    },
    {
      minWidth: "24%",
      name: (
        <span className="cell-header" style={{ fontSize: "14px" }}>
          {props.t("Name")}
        </span>
      ),
      cell: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium">
              <span className="avatar-xs me-3" style={{ fontSize: "14px" }}>
                {cell.name[0]}
              </span>
              <div className="cell-title" style={{ fontSize: "14px" }}>
                {cell.name}
              </div>
            </div>
          </React.Fragment>
        );
      }
    },
    {
      minWidth: "8%",
      name: (
        <span className="cell-header" style={{ fontSize: "14px" }}>
          {props.t("Card")}
        </span>
      ),
      selector: (row) => (
        <div className="d-flex flex-column">
          <div className="cell-title" style={{ fontSize: "14px" }}>
            {row.card.type}
          </div>
          <div className="cell-subtitle mt-2" style={{ fontSize: "14px" }}>
            {row.card.number}
          </div>
        </div>
      )
    },
    {
      minWidth: "16%",
      name: (
        <span className="cell-header" style={{ fontSize: "14px" }}>
          {props.t("Last Transaction")}
        </span>
      ),
      selector: (row) => (
        <div className="d-flex flex-column">
          <div className="cell-title" style={{ fontSize: "14px" }}>
            {row.lastTransaction.date}
          </div>
          <div className="cell-subtitle mt-2" style={{ fontSize: "14px" }}>
            {row.lastTransaction.amount}
          </div>
        </div>
      )
    },
    {
      minWidth: "10%",
      name: (
        <span className="cell-header" style={{ fontSize: "14px" }}>
          {props.t("Status")}
        </span>
      ),
      selector: (cell) => {
        switch (cell.status) {
          case "Pending":
            return (
              <span
                className=""
                style={{
                  color: "#FF9548",
                  textAlign: "right",
                  fontFamily: "Inter, sans-serif",
                  fonSize: "16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "normal"
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    style={{ strokeWidth: "4" }}
                    cx="8"
                    cy="8"
                    r="6"
                    fill="white"
                    stroke="#FF9548"
                  />
                </svg>
                {props.t(cell.status)}
              </span>
            );
          case "Done":
            return (
              <span
                className=""
                style={{
                  color: "#17E383",
                  textAlign: "right",
                  fontFamily: "Inter, sans-serif",
                  fonSize: "16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "normal"
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="8"
                    cy="8"
                    r="6"
                    fill="white"
                    stroke="#17E383"
                    style={{ strokeWidth: "4" }}
                  />
                </svg>
                {props.t(cell.status)}
              </span>
            );
        }
      }
    },
    {
      minWidth: "12%",
      name: (
        <span className="cell-header" style={{ fontSize: "14px" }}>
          {props.t("Total Used")}
        </span>
      ),
      selector: (row) => (
        <div
          className="totalUsed_text"
          style={{
            color: "#313A4E",
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontHeight: "500",
            lineHeight: "normal"
          }}
        >
          {row.totalUsed}
        </div>
      )
    },
    {
      minWidth: "8%",
      cell: (cell) => {
        return (
          <>
            {isMoreClicked !== cell.id && (
              <Button
                onClick={() => setIsMoreClicked(cell.id)}
                className="btn"
                tag="button"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  transform: "rotate(90deg)"
                }}
              >
                <i
                  className="ri-more-fill align-middle"
                  style={{ color: "#313A4E", fontSize: "14px" }}
                ></i>
              </Button>
            )}
            {isMoreClicked === cell.id && (
              <>
                <Button
                  className="btn"
                  tag="button"
                  style={{ backgroundColor: "transparent", border: "none" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                  >
                    <path
                      d="M3.5913 20.4112C3.63005 19.8224 3.75925 19.2465 3.85614 18.6706C4.06284 17.4153 4.28247 16.16 4.5021 14.9047C4.54085 14.6976 4.4698 14.5553 4.32769 14.4129C3.06807 13.1835 1.81492 11.9541 0.561763 10.7182C-0.148789 10.0129 -0.187547 8.95821 0.458409 8.20115C0.787847 7.81291 1.2271 7.63821 1.72448 7.56703C3.42981 7.32115 5.13513 7.07526 6.84046 6.83585C7.03424 6.80997 7.1376 6.70644 7.21511 6.54467C7.9838 4.97231 8.76541 3.40642 9.53409 1.83406C9.75372 1.38759 10.0896 1.06406 10.5547 0.889355C11.4526 0.546412 12.4151 0.934649 12.8543 1.82759C13.5519 3.22525 14.2625 4.6229 14.9214 6.04643C15.1733 6.58997 15.464 6.8682 16.097 6.93291C17.6085 7.09467 19.1072 7.35997 20.6122 7.56703C21.5618 7.70291 22.1755 8.20115 22.3499 9.03586C22.492 9.72174 22.2917 10.3106 21.7943 10.7959C20.567 11.9994 19.3397 13.1965 18.1059 14.3935C17.9186 14.5747 17.8734 14.7494 17.9186 14.9953C18.2222 16.7035 18.5193 18.4118 18.7971 20.12C18.9134 20.8447 18.6873 21.4724 18.0866 21.9124C17.4858 22.3589 16.814 22.4171 16.1487 22.0741C14.6242 21.2847 13.1062 20.4824 11.5947 19.6735C11.3105 19.5183 11.0908 19.5312 10.8131 19.68C9.30801 20.4888 7.79647 21.2847 6.27847 22.0677C5.2837 22.5789 4.15328 22.1518 3.72049 21.1359C3.62359 20.89 3.58484 20.6571 3.5913 20.4112ZM17.221 20.3983C17.2145 20.3788 17.2081 20.3465 17.2016 20.3141C16.9238 18.7094 16.6848 17.0982 16.3619 15.5C16.1616 14.5165 16.3812 13.7529 17.1305 13.067C18.3062 11.9865 19.4237 10.8476 20.567 9.72821C20.6704 9.62468 20.8319 9.53409 20.7802 9.35292C20.7221 9.14586 20.5283 9.17174 20.3797 9.14586C18.7002 8.8935 17.0207 8.64762 15.3412 8.40821C14.6178 8.30468 14.1075 7.94879 13.7845 7.29526C13.0416 5.77467 12.2859 4.25407 11.5366 2.73995C11.459 2.58466 11.4203 2.37113 11.2007 2.37113C10.981 2.3776 10.9423 2.59113 10.8712 2.74642C10.1219 4.26701 9.36615 5.78114 8.62329 7.30173C8.32616 7.9035 7.86107 8.27233 7.20219 8.38233C6.7371 8.45997 6.26556 8.51821 5.79401 8.58939C4.5021 8.77703 3.21664 8.97115 1.92473 9.1588C1.802 9.17821 1.68573 9.19762 1.63405 9.33351C1.58237 9.47586 1.67927 9.55998 1.76324 9.6441C2.14436 10.0194 2.51901 10.3882 2.90012 10.7635C3.79154 11.637 4.69588 12.5041 5.58084 13.3841C6.00717 13.8047 6.20096 14.3288 6.11053 14.9241C5.98133 15.7912 5.81985 16.6582 5.67128 17.5253C5.50979 18.4571 5.35476 19.3824 5.19327 20.3141C5.17389 20.4306 5.18035 20.5212 5.27078 20.5988C5.36122 20.683 5.46457 20.6571 5.56146 20.6118C5.6196 20.5859 5.67774 20.5535 5.73587 20.5212C7.23449 19.7318 8.73311 18.9488 10.2253 18.153C10.8841 17.7971 11.5236 17.8035 12.1825 18.1594C13.384 18.8065 14.5919 19.4341 15.7934 20.0683C16.1422 20.2494 16.491 20.4435 16.8463 20.6183C17.053 20.7218 17.221 20.6118 17.221 20.3983Z"
                      fill="#FFA412"
                    />
                  </svg>
                </Button>
                <Button
                  className="btn"
                  tag="button"
                  style={{
                    borderRadius: "8.08px",
                    background: "#E8F7F7",
                    border: "none"
                  }}
                >
                  {svgs.pdf_icon}
                </Button>
              </>
            )}
          </>
        );
      }
    }
  ];

  // const [isOfferSelected, setIsOfferSelected] = useState("basic");
  // modal
  const [modal_list, setmodal_list] = useState(false);
  const [modal_plans, setmodal_plans] = useState(false);
  const [show_calculator, showCalculator] = useState(false);
  const [show_one_shot_calculator, showOneShotCalculator] = useState(false);
  const [modal_payment_method, setmodal_payment_method] = useState(false);
  function tog_list() {
    setmodal_list(!modal_list);
  }
  const tog_plans = () => {
    setmodal_plans(!modal_plans);
  };

  const onShowCalculator = () => {
    showCalculator(!show_calculator);
  };
  const onShowOneShotCalculator = () => {
    showOneShotCalculator(!show_one_shot_calculator);
  };
  const tog_payment_method = () => {
    setmodal_payment_method(!modal_payment_method);
  };
  useEffect(() => {
    handleFetchStripeInfos();
    handleGetStripeInvoicesList();
  }, []);

  const handleInteraction = (event) => {
    console.log("Interaction event:", event);
  };

  const handleSubmit = (event) => {
    console.log("Submit event:", event);
  };

  const {
    active_subscription,
    client_data,
    number_of_credits,
    number_of_credits_included,
    userPlan,
    loadingState
  } = useSelector((state) => {
    return {
      loadingState: state.subscription.loadingState,
      userPlan: state.subscription.userPlan,
      number_of_credits: state.subscription.subscriptionCredits,
      number_of_credits_included:
        state.subscription.subscriptionIncludedCredits,
      consumed_email_count: state.GeneralStateRedux.consumed_email_count,
      client_data: state.GeneralStateRedux.client_data,
      user_plan: state.subscription.userPlan,
      active_subscription: state.subscription.subscription
        ? {
            id: state.subscription.subscription.id,
            next_billed_at: state.subscription.subscription.current_period_end,
            trialing: state.subscription.subscription.status === "trialing",
            active: state.subscription.subscription.status === "active",
            past_due: state.subscription.subscription.status === "past_due",
            pause: state.subscription.subscription.pause,
            cancel_at_period_end:
              state.subscription.subscription.cancel_at_period_end
          }
        : state.subscription.subscription
    };
  });

  const handleFetchStripeInfos = async () => {
    setLoadingStripeInfos(true);
    try {
      console.log({ client_data: props.client_data });

      const subscription_plan = await getStripeSubscription(
        props.client_data.plan_id,
        props.client_data.stripe_region,
        true
      );
      console.log({ subscription_plan });
      setActiveSubscriptionPlan(subscription_plan);

      const payment_method = await getStripePaymentMethod(
        props.client_data.stripe_customer_id,
        props.client_data.stripe_region
      );
      console.log({ payment_method });
      setPrimaryPaymentSource(payment_method);

      setLoadingStripeInfos(false);
    } catch (error) {
      setLoadingStripeInfos(false);
      // console.log({ error });
    }
  };
  const handleGetStripeInvoicesList = async () => {
    const invoiceList = await getStripeInvoicesList(
      props.client_data.stripe_customer_id,
      100,
      props.client_data.stripe_region
    );
    console.log({ invoiceList });
    setInvoiceList(invoiceList);
  };

  // function formatDate(millisec, short = false) {
  //   const options = short ? { day: "2-digit", month: "short", year: "2-digit" } : { day: "2-digit", month: "long", year: "numeric" };
  //   const date = new Date(millisec);
  //   return date.toLocaleDateString(props.i18n.language + "-" + props.i18n.language.toUpperCase(), options);
  //   // return "";
  // }

  return (
    <React.Fragment>
      <Modal
        isOpen={modal_list}
        toggle={tog_list}
        centered
        className="billing-page-modal"
      >
        <ModalBody>
          <Button
            className="close_button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: "0px",
              float: "right"
            }}
            onClick={() => {
              tog_list();
            }}
          >
            {svgs.close_icon}
          </Button>
          <h1
            className="modal_title"
            style={{ marginTop: "8%", marginBottom: "6%" }}
          >
            {props.t("Add ons")}
          </h1>
          <Row
            className="gap-5 mb-5"
            style={{ paddingLeft: "3%", paddingRight: "3%" }}
          >
            <Col xl={12}>
              <div className="billing-page-addOn d-flex align-items-center justify-content-between">
                <div className="addOn_label">
                  <input
                    className="form-check-input mt-0 me-3"
                    type="checkbox"
                  />
                  eget congue elit diam eget nulla
                </div>
                <span className="addOn_cost">€4.50</span>
              </div>
            </Col>
            <Col xl={12}>
              <div className="billing-page-addOn d-flex align-items-center justify-content-between">
                <div className="addOn_label">
                  <input
                    className="form-check-input mt-0 me-3"
                    type="checkbox"
                  />
                  In vel nibh tellus. Fusce tincidunt elit nec tortor
                </div>
                <span className="addOn_cost">€2.00</span>
              </div>
            </Col>
            <Col xl={12}>
              <div className="billing-page-addOn d-flex align-items-center justify-content-between">
                <div className="addOn_label">
                  <input
                    className="form-check-input mt-0 me-3"
                    type="checkbox"
                  />
                  Vongue elit diam eget nulla
                </div>
                <span className="addOn_cost">€3.00</span>
              </div>
            </Col>
            <Col xl={12}>
              <div className="billing-page-addOn d-flex align-items-center justify-content-between">
                <div className="addOn_label">
                  <input
                    className="form-check-input mt-0 me-3"
                    type="checkbox"
                  />
                  In vel nibh tellus. Fusce tincidunt elit nec tortor
                </div>
                <span className="addOn_cost">€4.50</span>
              </div>
            </Col>
            <Button className="addOn-modal-button mx-auto w-auto">
              {props.t("go next")}
            </Button>
          </Row>
        </ModalBody>
      </Modal>
      {/* <Modal isOpen={modal_plans} toggle={tog_plans} centered className="modal_wrapper__90x90">
        <ModalBody
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}>
          <Button
            className="close_button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: "0px",
              position: "absolute",
              right: "1rem",
            }}
            onClick={() => {
              tog_plans();
            }}>
            <CrossOutlined height={26} />
          </Button>
          <h1 className="modal_title" style={{ marginTop: "2%", marginBottom: "2%" }}>
            {props.t("Plans")}
          </h1>
          <Row className="mb-5 plan-details" style={{ paddingLeft: "2%", paddingRight: "2%", overflow: "auto" }}>
            <Row>
              <Col lg={4}></Col>
              {listPlans &&
                listPlans.map((plan, index) => (
                  <Col lg={2}>
                    <Card className="offer-card" style={{ padding: "0px", background: StaticData.getStylePlan(index).background }}>
                      <CardBody className="d-flex" style={{ flexDirection: "column" }}>
                        <h2
                          style={{
                            color: StaticData.getStylePlan(index).color,
                            textAlign: "center",
                            fontWeight: "700",
                          }}>
                          {plan.price / 100 + "€"}
                        </h2>
                        <h6 className="offer-title text-center" style={{ color: StaticData.getStylePlan(index).color, marginBottom: "0px" }}>
                          {props.t(plan.external_name)}
                        </h6>
                        <span
                          className="font-primary"
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: "12px",
                            color: StaticData.getStylePlan(index).color,
                          }}>
                          {"+ 0,35€/email supp."}
                        </span>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
            </Row>
            {listFeatureTitle.map((name, index) => (
              <>
                <Row>
                  <Col lg={1}></Col>
                  <Col lg={3}>
                    <p
                      className="font-primary"
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        height: "28px",
                      }}>
                      {name}
                    </p>
                  </Col>
                  {listPlans &&
                    listPlans.map((plan, i) =>
                      listFeatures[plan.item_id] && listFeatures[plan.item_id].filter((bill) => bill.feature_name === name).length > 0 ? (
                        listFeatures[plan.item_id]
                          .filter((bill) => bill.feature_name === name)
                          .map((feature, index) => (
                            <Col lg={2}>
                              {feature.value !== "true" && feature.value !== "false" && (
                                <p className="font-primary" style={{ height: "28px", textAlign: "center" }}>
                                  {feature.name}
                                </p>
                              )}

                              {feature.value === "true" && (
                                <p style={{ textAlign: "center" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="black"
                                    style={{
                                      height: "28px",
                                      width: "28px",
                                    }}>
                                    <path
                                      fill-rule="evenodd"
                                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </p>
                              )}
                              {feature.value === "false" && (
                                <p style={{ textAlign: "center" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="black"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    class="icon icon-tabler icons-tabler-outline icon-tabler-x">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M18 6l-12 12" />
                                    <path d="M6 6l12 12" />
                                  </svg>
                                </p>
                              )}
                            </Col>
                          ))
                      ) : (
                        <Col lg={2}>
                          <div>
                            <p style={{ textAlign: "center" }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="black"
                                stroke="currentColor"
                                stroke-width="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-x">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                              </svg>
                            </p>
                          </div>
                        </Col>
                      )
                    )}
                </Row>
              </>
            ))}
            <Row>
              <Col lg={4}></Col>
              {listPlans &&
                listPlans.map((plan, index) => (
                  <Col lg={2} key={index} className="d-flex">
                    <button
                      //  to={`https://fintinos-test.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=${plan.id}&utm_source=cb-app-copy`}
                      onClick={async () => {
                        setLoading(true);

                        let subscription_url;

                        const language = localStorage.getItem("I18N_LANGUAGE");
                        const locale = language ? (language === "en" ? "en-En" : language === "fr" ? "fr-FR" : "en-En") : "en-En";

                        if (active_subscription && active_subscription.external_name) {
                          subscription_url = await updateSubscriptionChargeBee(
                            props.userInfos.$id,
                            props.userInfos.email,
                            props.userInfos.prefs["first_name"] ?? undefined,
                            props.userInfos.prefs["last_name"] ?? undefined,
                            plan.id,
                            subscriptions[0].id,
                            locale
                            //   data.token,
                          );
                        } else {
                          subscription_url = await subscriptionChargeBee(
                            props.userInfos.$id,
                            props.userInfos.email,
                            props.userInfos.prefs["first_name"] ?? undefined,
                            props.userInfos.prefs["last_name"] ?? undefined,
                            plan.id,
                            locale
                            //   data.token,
                          );
                        }
                        setLoading(false);
                        if (subscription_url) {
                          const url = subscription_url.subscription.hosted_page.url;
                          if (url) {
                            window.location.href = url;
                          }
                        }
                      }}
                      style={{
                        backgroundColor: "#563bff",
                        borderRadius: "20px",
                        color: "white",
                        border: "none",
                      }}
                      className="simple-text font-primary px-3 py-2 mx-auto">
                      <p style={{ textAlign: "center" }} className="mb-0">
                        {props.t("Sélectionner")}
                      </p>
                    </button>
                  </Col>
                ))}
            </Row>
          </Row>
        </ModalBody>
      </Modal> */}

      <CalculatorModal
        isOpen={show_calculator}
        toggle={onShowCalculator}
        upgrade_downgrade={
          activeSubscriptionPlan && activeSubscriptionPlan.name
        }
        has_consumed_trial={client_data && client_data.has_consumed_trial}
      />

      <CalculatorOneShotModal
        isOpen={show_one_shot_calculator}
        toggle={onShowOneShotCalculator}
      />

      <Modal
        isOpen={modal_payment_method}
        toggle={tog_payment_method}
        centered
        className="modal_wrapper__90x90"
      >
        <ModalBody
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%"
          }}
        >
          <Button
            className="close_button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: "0px",
              position: "absolute",
              right: "1rem"
            }}
            onClick={() => {
              tog_payment_method();
            }}
          >
            <CrossOutlined height={26} />
          </Button>
          <h1
            className="modal_title"
            style={{ marginTop: "2%", marginBottom: "2%" }}
          >
            {props.t("Paiements")}
          </h1>
          <Row
            className="mb-5  facturation mx-auto"
            style={{ width: "70%", flex: "1", overflow: "auto" }}
          >
            <Row className="payment-information">
              <Col xxl={4} xl={5}>
                <Card className="credit-card" style={{ position: "relative" }}>
                  <CardBody
                    className="d-flex flex-column justify-content-between"
                    style={{ padding: "0" }}
                  >
                    <button
                      style={{
                        borderRadius: "6.756px",
                        background: "#F10944",
                        width: "40px",
                        height: "40px",
                        border: "none",
                        position: "absolute",
                        right: "0",
                        top: "0",
                        transform: "translate(-50%, 50%)",
                        zIndex: "1"
                      }}
                    >
                      {svgs.bin_icon}
                    </button>
                    <div>
                      <h6 className="card-title">Lorem Ipsum</h6>
                      <p className="card-account-type">
                        {props.t("PREMIUM ACCOUNT")}
                      </p>
                    </div>
                    <div className="row" style={{ flexWrap: "nowrap" }}>
                      <Col xl={3}>
                        <div className="credit-card-digits">5789</div>
                      </Col>
                      <Col xl={3}>
                        <div className="credit-card-digits">* * * *</div>
                      </Col>
                      <Col xl={3}>
                        <div className="credit-card-digits">* * * *</div>
                      </Col>
                      <Col xl={3}>
                        <div className="credit-card-digits">5789</div>
                      </Col>
                    </div>
                    <div className="row">
                      <Col xl={4}>
                        <div className="d-flex flex-column">
                          <div className="info-title">
                            {props.t("Card holder")}
                          </div>
                          <span className="info mt-2">Mike Smith</span>
                        </div>
                      </Col>
                      <Col className="ps-2 pe-0" xl={3}>
                        <div className="d-flex flex-column">
                          <div className="info-title">
                            {props.t("Expire date")}
                          </div>
                          <span className="info mt-2">06/21</span>
                        </div>
                      </Col>
                      <Col xl={2}></Col>

                      <div className="credit-card-digits d-flex align-items-center col-3">
                        {svgs["visa"]}
                      </div>
                    </div>
                    <div
                      className=""
                      style={{
                        position: "absolute",
                        bottom: "0",
                        right: "0"
                      }}
                    >
                      {svgs.credit_card_vector}
                    </div>
                  </CardBody>
                </Card>
                <button className="add-credit-card w-100">
                  <span
                    style={{
                      zIndex: "2",
                      borderRadius: "6.756px",
                      background: "#05B714",
                      width: "40px",
                      height: "40px",
                      border: "none",
                      position: "absolute",
                      right: "0",
                      top: "0",
                      transform: "translate(-50%, 50%)"
                    }}
                  >
                    {svgs.check_icon}
                  </span>
                  <span
                    className="ellipse"
                    style={{
                      right: "0",
                      top: "0",
                      transform: "translate(32%, -68%)"
                    }}
                  ></span>
                  <span
                    className="ellipse"
                    style={{
                      left: "0",
                      bottom: "0",
                      transform: "translate(-32%, 68%)",
                      fontSize: "14px"
                    }}
                  ></span>
                  {props.t("Add New")}
                  <span
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      backgroundColor: "#fff"
                    }}
                  >
                    {svgs.plus_credit_card_icon}
                  </span>
                </button>
              </Col>
              <Col xxl={8} xl={7}>
                <Card
                  style={{
                    backgroundColor: "transparent",
                    boxShadow: "none"
                  }}
                >
                  <CardBody>
                    <h5
                      style={{
                        color: "var(--greys-blue-grey-900, #151D48)",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "14px",

                        fontWeight: "600",
                        lineHeight: "140%"
                      }}
                    >
                      {props.t("Pay using credit cards")}
                    </h5>
                    <div className="mt-3 d-flex justify-content-between align-items-center col-xxl-6 col-xl-8">
                      {svgs.master_card_logo}
                      {svgs.visa_logo_color}
                      {svgs.amex_logo}
                    </div>
                    <Row style={{ marginTop: "61px" }}>
                      <label className="form-label" htmlFor="card-number">
                        {props.t("Credit Card Number")}
                      </label>
                      <InputGroup
                        className=""
                        style={{
                          backgroundColor: "transparent",
                          height: "fit-content"
                        }}
                      >
                        <Input
                          placeholder="1234  5678  9010  2323"
                          id="card-number"
                          type="text"
                          style={{
                            borderRadius: "0",
                            height: "42px"
                          }}
                          className="form-input"
                          // value={}
                          // onChange={(e) => ()}
                          // onKeyPress={}
                        />
                        <InputGroupText
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            padding: "0"
                          }}
                        >
                          <span
                            className="btn h-100"
                            style={{
                              borderRadius: "0",
                              padding: "0 0 8px 0",
                              border: "none",
                              borderBottom: "solid 3px #E5E5E5"
                            }}
                          >
                            {svgs["mastercard"]}
                          </span>
                        </InputGroupText>
                      </InputGroup>
                    </Row>
                    <Row style={{ marginTop: "63px" }}>
                      <label className="form-label" htmlFor="name">
                        {props.t("Name")}
                      </label>
                      <div className="d-flex col-12" style={{}}>
                        <input
                          id="name"
                          placeholder="John Smith"
                          type="text"
                          className="form-input w-100"
                        />
                      </div>
                    </Row>
                    <Row style={{ marginTop: "65px" }}>
                      <Col xl={6}>
                        <label
                          className="form-label"
                          htmlFor="expiration-date"
                          style={{ fontSize: "14px" }}
                        >
                          {props.t("Expiration Date")}
                        </label>
                        <div className="d-flex col-12" style={{}}>
                          <input
                            id="expiration-date"
                            placeholder="11/34"
                            type="date"
                            className="form-input w-100"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <label
                          className="form-label"
                          htmlFor="cvv"
                          style={{ fontSize: "14px" }}
                        >
                          CVV
                        </label>
                        <InputGroup
                          className=""
                          style={{
                            backgroundColor: "transparent",
                            height: "fit-content"
                          }}
                        >
                          <Input
                            placeholder="245"
                            id="cvv"
                            type=""
                            style={{
                              borderRadius: "0",
                              height: "42px"
                            }}
                            className="form-input"
                            // value={}
                            // onChange={(e) => ()}
                            // onKeyPress={}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              padding: "0"
                            }}
                          >
                            <button
                              className="btn h-100"
                              style={{
                                borderRadius: "0",
                                padding: "0 0 8px 0",
                                border: "none",
                                borderBottom: "solid 3px #E5E5E5"
                              }}
                            >
                              <img src={eye_icon} alt="" />
                            </button>
                          </InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "60px" }}
                      className="justify-content-between"
                    >
                      <div
                        className="d-flex align-items-center col-auto"
                        style={{
                          color: "#313131",
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "140%"
                        }}
                      >
                        <input
                          className="form-check-input mt-0 me-2"
                          type="checkbox"
                        />
                        <label
                          className="form-check-label"
                          style={{ fontSize: "14px" }}
                        >
                          {props.t("Save Card")}
                        </label>
                      </div>
                      <button
                        className="col-auto view-button"
                        style={{ backgroundColor: "#563bff" }}
                      >
                        {props.t("Submit")}
                      </button>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Row>
        </ModalBody>
      </Modal>
      <Container
        fluid={true}
        style={{ maxWidth: "100%", paddingLeft: "8%", paddingRight: "8%" }}
        className="facturation"
      >
        <Col lg="12">
          <Card style={{ backgroundColor: "transparent", boxShadow: "none" }}>
            <CardBody style={{ padding: "0" }}>
              <Row className="justify-content-between flex-row mb-4">
                <Col xl={11}>
                  <div className="" style={{ width: "fit-content" }}>
                    <h3
                      className="section-title font-primary"
                      style={{ fontSize: "18px" }}
                    >
                      {props.t("Facturation")}
                    </h3>
                  </div>
                </Col>
              </Row>
              <div className="inter-ligne"></div>
              <Row className="mt-3">
                {/* <Card
                        className="table-card ps-xxl-5 pt-xxl-3 ps-xl-2 pt-xl-3 pb-2 pe-2"
                        style={{
                          boxShadow: "none",
                          borderRadius: "30px",
                          background: "#FFF",
                        }}>
                        <CardBody style={{ padding: "0" }}>
                          <DataTable columns={columns} data={data} />
                        </CardBody>
                      </Card> */}
                <Col xl={0} xxl={1}></Col>
                <Col xl={8} xxl={8}>
                  <div
                    className="w-100 d-flex justify-content-center gap-4 mb-4"
                    style={{ flex: "1" }}
                  >
                    <Col>
                      <div
                        className={`pricing_content-title-2 ${
                          userPlan === "MAAIA_PLAN_STARTER" &&
                          "pricing_content_active"
                        }`}
                      >
                        <div className="pricing_text-margin">
                          <div className="text-size-medium text-weight-medium mb-0">
                            STARTER
                          </div>
                          <div className="text-size-large text-weight-bold">
                            $29
                          </div>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://synibox.io/pricing"
                            className="my-2"
                          >
                            <span className="font-size-14">
                              {props.t("See details")}
                            </span>
                          </a>
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <div
                        className={`pricing_content-title ${
                          userPlan === "MAAIA_PLAN_GROWTH" &&
                          "pricing_content_active"
                        }`}
                      >
                        <div className="pricing_text-margin">
                          <div className="text-size-medium text-weight-medium mb-0">
                            GROWTH
                          </div>
                          <div className="text-size-large text-weight-bold">
                            $99
                          </div>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://synibox.io/pricing"
                            className="my-2"
                          >
                            <span className="font-size-14">
                              {props.t("See details")}
                            </span>
                          </a>
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <div
                        className={`pricing_content-title-2 ${
                          userPlan === "MAAIA_PLAN_BUSINESS" &&
                          "pricing_content_active"
                        }`}
                      >
                        <div className="pricing_text-margin">
                          <div className="text-size-medium text-weight-medium mb-0">
                            BUSINESS
                          </div>
                          <div className="text-size-large text-weight-bold">
                            $199
                          </div>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://synibox.io/pricing"
                            className="my-2"
                          >
                            <span className="font-size-14">
                              {props.t("See details")}
                            </span>
                          </a>
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <div
                        className={`pricing_content-title ${
                          userPlan === "MAAIA_PLAN_PRO" &&
                          "pricing_content_active"
                        }`}
                      >
                        <div className="pricing_text-margin">
                          <div className="text-size-medium text-weight-medium mb-0">
                            PRO
                          </div>
                          <div className="text-size-large text-weight-bold">
                            $399
                          </div>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://synibox.io/pricing"
                            className="my-2"
                          >
                            <span className="font-size-14">
                              {props.t("See details")}
                            </span>
                          </a>
                        </div>
                      </div>
                    </Col>
                  </div>
                  <h4
                    className="font-primary mb-1"
                    style={{
                      color: "#151d48",
                      fontSize: "16px",
                      fontWeight: "bold"
                    }}
                  >
                    {props.t("Billing History")}
                  </h4>
                  <p
                    style={{
                      fontWeight: "500"
                    }}
                  >
                    {props.t("Manage billing information and view receips")}
                  </p>
                  <div className="bills-list mt-3 pe-xxl-5 pe-xl-3">
                    {/* Table Head */}
                    {/* <Row
                      className="w-100"
                      style={{
                        fontWeight: "500",
                      }}>
                      <Col xxl={5} xl={4}>
                        {props.t("Date")}
                      </Col>
                      <Col xxl={5} xl={5}>
                        {props.t("Type")}
                      </Col>
                      <Col xxl={2} xl={3}>
                        {props.t("Receipt")}
                      </Col>
                    </Row> */}

                    {/* Table Body */}
                    {invoiceList &&
                      // invoiceList.slice(0, 4).map((invoice) => (
                      //   <Row
                      //     key={invoice.id}
                      //     className="w-100 my-3 align-items-center p-2"
                      //     style={{
                      //       fontWeight: "600",
                      //       color: "#151d48",
                      //       cursor: "pointer",
                      //       boxShadow: selectedInvoice === invoice.id ? "5px 10px 20px -5px #dfdaff" : "none",
                      //       borderRadius: selectedInvoice === invoice.id ? "10px" : "none",
                      //     }}
                      //     onClick={() => {
                      //       setSelectedInvoice(invoice.id);
                      //     }}>
                      //     <Col xxl={5} xl={4}>
                      //       {formatDate(invoice.date * 1000, true)}
                      //     </Col>
                      //     <Col xxl={5} xl={5}>
                      //       {invoice.name}
                      //     </Col>
                      //     <Col xxl={2} xl={3}>
                      //       <a
                      //         className="py-1 px-3"
                      //         href={invoice.invoice_pdf_url}
                      //         style={{
                      //           backgroundColor: "transparent",
                      //           border: "1px solid #e1e3e5",
                      //           borderRadius: "8px",
                      //           fontWeight: "600",
                      //           color: "#151d48",
                      //         }}>
                      //         {props.t("Download")}
                      //       </a>
                      //     </Col>
                      //   </Row>
                      // ))
                      ScrollVertical(invoiceList, props.t, props)}
                    {invoiceList === undefined && (
                      <Row className="w-100 my-3 align-items-center justify-content-center p-2">
                        <Spinner color="primary">Loading...</Spinner>
                      </Row>
                    )}
                    {invoiceList === null && !loadingStripeInfos && (
                      <Row className="w-100 my-3 align-items-center justify-content-center p-2">
                        {props.t("Aucune transaction effectuée")}
                      </Row>
                    )}
                    <Row className="mt-4 pt-2">
                      <h4
                        className="font-primary mb-1"
                        style={{
                          color: "#151d48",
                          fontSize: "16px",
                          fontWeight: "bold"
                        }}
                      >
                        {props.t("Payment Method")}
                      </h4>
                      <p
                        style={{
                          fontWeight: "500"
                        }}
                      >
                        {props.t("Manage your payment information")}
                      </p>
                      {primaryPaymentSource ? (
                        <Card
                          className="p-0"
                          style={{ backgroundColor: "#f5f5f5" }}
                        >
                          <CardBody>
                            <Row className="d-flex justify-content-between">
                              <Col
                                md={7}
                                className="d-flex"
                                style={{ flexDirection: "column" }}
                              >
                                <div
                                  className="p-2 d-flex align-items-end"
                                  style={{
                                    border: "1px solid #e1e3e5",
                                    color: "#00359A",
                                    backgroundColor: "#c0d5fa",
                                    borderRadius: "10px",
                                    flex: "1",
                                    maxWidth: "200px",
                                    minHeight: "90px"
                                  }}
                                >
                                  {svgs[primaryPaymentSource.card.brand]}
                                </div>
                                {/* <button
                                  className="py-1 px-3 mt-3"
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "1px solid #e1e3e5",
                                    borderRadius: "8px",
                                    fontWeight: "600",
                                    color: "#151d48",
                                    width: "fit-content"
                                  }}
                                  onClick={tog_payment_method}>
                                  {props.t("Modifier")}
                                </button> */}
                              </Col>
                              <Col md={4}>
                                <div
                                  className="d-flex gap-1"
                                  style={{ flexDirection: "column" }}
                                >
                                  <div
                                    className="d-flex justify-content-between gap-1"
                                    style={{
                                      textTransform: "capitalize"
                                    }}
                                  >
                                    {props.t("Type")}
                                    <span
                                      style={{
                                        color: "black",
                                        fontWeight: "600"
                                      }}
                                    >
                                      {primaryPaymentSource.card.brand}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between gap-1">
                                    {props.t("Card number")}
                                    <span
                                      style={{
                                        color: "black",
                                        fontWeight: "600"
                                      }}
                                    >{`**** **** **** ${primaryPaymentSource.card.last4}`}</span>
                                  </div>
                                  <div className="d-flex justify-content-between gap-1">
                                    {props.t("Exp. date")}
                                    <span
                                      style={{
                                        color: "black",
                                        fontWeight: "600"
                                      }}
                                    >
                                      {primaryPaymentSource.card.exp_month} •{" "}
                                      {primaryPaymentSource.card.exp_year}
                                    </span>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      ) : (
                        <span className="ms-1">
                          {loadingStripeInfos
                            ? props.t("Chargement") + "..."
                            : props.t("Aucun moyen de paiement ajouté")}
                        </span>
                      )}
                    </Row>
                  </div>
                </Col>
                <Col xl={4} xxl={3}>
                  <Card
                    className="cream cream-card"
                    style={{
                      // backgroundColor: "#fcba03",
                      border: "1px solid",
                      borderColor:
                        active_subscription &&
                        active_subscription.cancel_at_period_end
                          ? "black"
                          : active_subscription && active_subscription.trialing
                          ? "#563bff"
                          : active_subscription && active_subscription.past_due
                          ? "#f10944"
                          : "none",
                      boxShadow: "none",
                      borderRadius: "18px"
                    }}
                  >
                    {active_subscription &&
                      active_subscription.trialing &&
                      !active_subscription.cancel_at_period_end && (
                        <div
                          className="py-2"
                          style={{
                            backgroundColor: "rgb(86, 59, 255)",
                            borderTopRightRadius: "8px",
                            borderTopLeftRadius: "8px",
                            fontWeight: "500",
                            color: "white",
                            textAlign: "center"
                          }}
                        >
                          {props.t("Période d'essai")}
                        </div>
                      )}
                    {active_subscription && active_subscription.past_due && (
                      <div
                        className="py-2 px-3 d-flex justify-content-between"
                        style={{
                          backgroundColor: "rgb(241, 9, 68)",
                          borderTopRightRadius: "8px",
                          borderTopLeftRadius: "8px",
                          fontWeight: "500",
                          color: "white"
                        }}
                      >
                        {props.t("Paiement en retard")}
                        <Link
                          className="underline-a"
                          style={{ color: "white" }}
                          to={
                            client_data?.stripe_region === "US"
                              ? `/retry-payment-checkout?region=US`
                              : `/retry-payment-checkout`
                          }
                        >
                          {props.t("Relancer")}
                        </Link>
                      </div>
                    )}
                    {active_subscription &&
                      active_subscription.cancel_at_period_end && (
                        <div
                          className="py-2 px-3 d-flex justify-content-between"
                          style={{
                            backgroundColor: "black",
                            borderTopRightRadius: "8px",
                            borderTopLeftRadius: "8px",
                            fontWeight: "500",
                            color: "white"
                          }}
                        >
                          {props.t("Scheduled cancellation")}
                          <span className="mb-0" style={{ color: "white" }}>
                            {formatDate(
                              props,
                              active_subscription.next_billed_at,
                              true,
                              true
                            )}
                          </span>
                        </div>
                      )}
                    <CardBody
                      className="d-flex flex-column"
                      style={{
                        color: "black"
                      }}
                    >
                      <span className="mb-2">{props.t("Your plan")}</span>

                      {userPlan === "MAAIA_PLAN_DIRECT_WORLD" ? (
                        <div>
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "800",
                              fontSize: "18px",
                              color: "#563bff",
                              marginBottom: "-10px"
                            }}
                          >
                            {props.t("Aucun")}
                          </p>
                          <div
                            className="mb-2 d-flex"
                            style={{ flexDirection: "column" }}
                          >
                            {/* <div className="d-flex justify-content-between">
                              {client_data.direct_credit > 0 && (
                                <span className="">{`${props.t("Crédits achetés:")} ${client_data.direct_credit ?? "00"}`}</span>
                              )}
                            </div> */}

                            {client_data?.offered_credits > 0 && (
                              <div className="d-flex justify-content-between">
                                <span className="">{`${props.t(
                                  "Crédits bonus"
                                )}: ${client_data.offered_credits}`}</span>
                              </div>
                            )}
                          </div>

                          <button
                            onClick={onShowCalculator}
                            // disabled={active_subscription === undefined}
                            style={{
                              backgroundColor: "#563bff",
                              borderRadius: "20px"
                            }}
                            className="mb-1 view-button simple-text font-primary"
                          >
                            {props.t("Choisir un plan")}
                          </button>
                        </div>
                      ) : loadingState ? (
                        <Spinner
                          style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            marginBottom: "16px"
                          }}
                          color="primary"
                        >
                          Loading...
                        </Spinner>
                      ) : active_subscription === undefined ||
                        !activeSubscriptionPlan ? (
                        <div>
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "800",
                              fontSize: "18px",
                              color: "#563bff",
                              marginBottom: "-10px"
                            }}
                          >
                            {props.t("Aucun")}
                          </p>
                          <button
                            onClick={onShowCalculator}
                            // disabled={active_subscription === undefined}
                            style={{
                              backgroundColor: "#563bff",
                              borderRadius: "20px"
                            }}
                            className="mb-1 view-button simple-text font-primary"
                          >
                            {props.t("Choisir un plan")}
                          </button>
                        </div>
                      ) : (
                        <>
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "800",
                              fontSize: "18px",
                              color: "#563bff",
                              marginBottom: "-10px"
                            }}
                          >
                            {activeSubscriptionPlan
                              ? activeSubscriptionPlan.name
                              : props.t("Aucun")}
                          </p>
                          <p
                            className="mb-0"
                            style={{
                              fontWeight: "600",
                              fontSize: "30px",
                              color: "black"
                            }}
                          >
                            {activeSubscriptionPlan &&
                              `$${activeSubscriptionPlan.amount}/${props.t(
                                "mois"
                              )}`}
                          </p>
                          <div
                            className="mb-2 d-flex"
                            style={{ flexDirection: "column" }}
                          >
                            {active_subscription && (
                              <span className="">{`${props.t(
                                "includes"
                              )} ${number_of_credits_included} ${props.t(
                                "Credits"
                              )}`}</span>
                            )}
                            <div className="d-flex justify-content-between">
                              <span className="">{`${props.t(
                                "Crédits achetés:"
                              )} ${client_data.direct_credit ?? "00"}`}</span>
                            </div>

                            {client_data.credit_carried_over > 0 && (
                              <div className="d-flex justify-content-between">
                                {active_subscription && (
                                  <span className="">{`${props.t(
                                    "Crédits reportés"
                                  )}: ${
                                    client_data.credit_carried_over
                                  }`}</span>
                                )}
                              </div>
                            )}

                            {client_data.offered_credits > 0 && (
                              <div className="d-flex justify-content-between">
                                <span className="">{`${props.t(
                                  "Crédits bonus"
                                )}: ${client_data.offered_credits}`}</span>
                              </div>
                            )}
                          </div>
                          <div className="d-flex justify-content-between">
                            {active_subscription && (
                              <span style={{ fontWeight: "600" }}>{`${props.t(
                                "Total des crédits:"
                              )} ${number_of_credits} ${
                                active_subscription.trialing
                                  ? `(${props.t("Période d'essai")})`
                                  : ""
                              }`}</span>
                            )}
                            {active_subscription &&
                              active_subscription.active &&
                              !active_subscription.pause && (
                                <Link
                                  className="underline-a"
                                  to={"#"}
                                  onClick={onShowOneShotCalculator}
                                >
                                  {props.t("Buy more")}
                                </Link>
                              )}
                          </div>
                          {active_subscription && (
                            <span className="mb-2">
                              {props.t(
                                active_subscription.cancel_at_period_end
                                  ? "Cancellation on"
                                  : active_subscription.trialing
                                  ? "Trial end"
                                  : "Renews on"
                              )}{" "}
                              {formatDate(
                                props,
                                active_subscription.next_billed_at,
                                false,
                                true
                              )}
                            </span>
                          )}
                        </>
                      )}
                      {/* {active_subscription && active_subscription.trialing ? (
                        <a
                          href={
                            props.client_data.stripe_region === "US"
                              ? `/trial-interruption?region=US&id=${active_subscription.id}`
                              : `/trial-interruption?id=${active_subscription.id}`
                          }
                          className="mb-2 view-button simple-text font-primary"
                          style={{
                            backgroundColor: "#563bff",
                            borderRadius: "20px"
                          }}>
                          {props.t("Écourter l'essai")}
                        </a>
                      ) : ( */}
                      {active_subscription &&
                        !active_subscription.cancel_at_period_end && (
                          <button
                            onClick={onShowCalculator}
                            disabled={active_subscription === undefined}
                            style={{
                              backgroundColor: "#563bff",
                              borderRadius: "20px"
                            }}
                            className="mb-1 view-button simple-text font-primary"
                          >
                            {active_subscription !== undefined
                              ? activeSubscriptionPlan &&
                                activeSubscriptionPlan.name
                                ? props.t("Changer de plan")
                                : props.t("Choisir un plan")
                              : props.t("Chargement") + "..."}
                          </button>
                        )}
                      {/* )} */}
                      {activeSubscriptionPlan &&
                        activeSubscriptionPlan.name &&
                        active_subscription &&
                        !active_subscription.cancel_at_period_end && (
                          // <a
                          //   href={
                          //     props.client_data.stripe_region === "US"
                          //       ? `/cancellation?region=US&id=${active_subscription.id}`
                          //       : `/cancellation?id=${active_subscription.id}`
                          //   }
                          //   style={{
                          //     //  backgroundColor: "black",
                          //     //    borderRadius: "20px",
                          //     color: "black",
                          //     fontSize: "12px"
                          //   }}
                          //   className="simple-text text-center mt-3">
                          //   {props.t(`Cancel ${active_subscription.trialing ? "trial" : "subscription"}`)}
                          // </a>

                          <div
                            className="underline-cancel-a simple-text text-center mt-3"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigate(
                                props.client_data.stripe_region === "US"
                                  ? `/cancellation?region=US&id=${active_subscription.id}`
                                  : `/cancellation?id=${active_subscription.id}`
                              );
                            }}
                          >
                            {props.t(
                              `Cancel ${
                                active_subscription.trialing
                                  ? "trial"
                                  : "subscription"
                              }`
                            )}
                          </div>
                        )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </React.Fragment>
  );
};

const ScrollVertical = (data, t, props) => {
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">{t("Date")}</span>,
      selector: (invoice) => formatDate(props, invoice.date, true, true),
      sortable: true
    },
    {
      name: <span className="font-weight-bold fs-13">{t("Type")}</span>,
      selector: (invoice) => invoice.name,
      sortable: true
    },
    {
      name: <span className="font-weight-bold fs-13">{t("Amount")}</span>,
      selector: (invoice) =>
        invoice.amount_due < 10
          ? "0" + invoice.amount_due.toFixed(2)
          : invoice.amount_due.toFixed(2),
      sortable: true
    },
    {
      name: <span className="font-weight-bold fs-13">{t("Receipt")}</span>,
      selector: (invoice) => (
        <a
          className="py-1 px-3"
          href={invoice.invoice_pdf_url}
          style={{
            backgroundColor: "transparent",
            border: "1px solid #e1e3e5",
            borderRadius: "8px",
            fontWeight: "600",
            color: "#151d48",
            display: "block"
          }}
        >
          {t("Download")}
        </a>
      ),
      sortable: false
    }
  ];
  return (
    <DataTable
      customStyles={{
        cells: {
          style: {
            fontWeight: "600",
            color: "rgb(21, 29, 72)",
            fontSize: "0.875rem"
          }
        },
        rows: { style: { borderBottom: "none" } }
      }}
      fixedHeader
      fixedHeaderScrollHeight="300px"
      columns={columns}
      data={data}
      pagination
    />
  );
};

export default withTranslation()(Facturation);
